
/* styles */
require("!!../../../../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"sourceMap\":true}!../../../../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-3296846a&scoped=true!../../../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./ParticipantsTable.vue")

var Component = require("!../../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./ParticipantsTable.vue"),
  /* template */
  require("!!../../../../../../node_modules/vue-loader/lib/template-compiler?id=data-v-3296846a!../../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./ParticipantsTable.vue"),
  /* scopeId */
  "data-v-3296846a",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/app/features/courses/pages/settings/ParticipantsTable.vue
// module id = 2221
// module chunks = 61